import React from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import { BannerTileContainer, TileTitle, TileBody } from './heroPanelStyles'

interface BannerStatusTileProps {
  title: string
  label: string | number
  statusColor?: string
}

const TileStatusColor = styled.div<{ color: string }>`
  background-color: ${props => props.color};
  margin-right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
`

const Count = styled.div<{ zeroValue: boolean }>`
  font-size: 28px;
  font-family: NEXWeb;
  color: ${props => (props.zeroValue ? constants.CORE_PRIMARY_6 : constants.CORE_PRIMARY)};
`

export const BannerStatusTile: React.FunctionComponent<BannerStatusTileProps> = props => (
  <BannerTileContainer>
    <TileTitle>
      {props.statusColor && <TileStatusColor color={props.statusColor} />}
      {props.title}
    </TileTitle>
    <TileBody>
      <Count zeroValue={props.label === 0}>{props.label}</Count>
    </TileBody>
  </BannerTileContainer>
)
